<template>
    <div class="">
       <img :src="data.url" alt="" class="img-responsive" width="30">
  </div>
</template>

<script>

export default {
  data () {
    return {
        data: {}
    }
  },
  mounted() {
  },
}
</script>